<block-ui>
    <div class="container" *ngIf="validatePollMessage && validatePollMessage.length > 0">
        <!-- <div class="logoContainer">
        <img src="https://21.edu.ar/sites/default/files/logos/logo-siglo21-25a.png">
      </div> -->
        <div style="padding-top: 50px;">
            <mat-card>
                <mat-card-content class="textContainer">
                    <div class="row">
                        <div class="col-md-12">
                            <h2>
                                <div [innerHTML]="validatePollMessage | safeHtml"></div>
                            </h2>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <div class="content" role="main" *ngIf="popupBlocked">
        <div class="row animate fadeInDown">
            <div class="col-md-6 col-sm-4">
                <img src="./../../assets/img/authenticate.svg" alt="">
            </div>
            <div class="col-md-6 col-sm-8">
                <div>
                    <p class="h1">Ups!</p>
                </div>
                <div>
                    <p class="h2 mb-3">Para completar el login necesitamos abrir una ventana emergente.
                        Por favor habilitá los pop-ups para {{window.location.origin}}</p>
                </div>
                <div>
                    <button mat-raised-button color="primary" (click)="openPopup()">Reintentar</button>
                </div>
            </div>
        </div>
    </div>
</block-ui>